import { useContext, useContextSelector } from 'use-context-selector';
import OrderContext, { OrderContextValue } from 'src/contexts/OrderContext';

// Overload for when no selector is provided. Returns the entire context value.
function useOrder(): OrderContextValue;
// Overload for when a selector is provided. Returns only the selected slice of state.
function useOrder<T>(selector: (state: OrderContextValue) => T): T;
// Implementation of the overloaded function.
function useOrder<T>(selector?: (state: OrderContextValue) => T): T | OrderContextValue {
  // If a selector function is passed, use useContextSelector for performance.
  if (selector) {
    return useContextSelector(OrderContext, selector);
  }
  // Otherwise, return the entire context value for backward compatibility.
  return useContext(OrderContext);
}

export default useOrder;
